import {
  AppBar,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";

import {Dispatch, SetStateAction} from "react";
import {CustomIconButton} from "ui";

interface PdfBigPreviewProps {
  fileUrl: string;
  setFileUrl: Dispatch<SetStateAction<string>>;
  fileName: string;
  handleDownloadFileAndClosePreview: () => void | Promise<void>;
}

const ImageBigPreview = (props: PdfBigPreviewProps) => {
  const {fileUrl, setFileUrl, fileName, handleDownloadFileAndClosePreview} =
    props;

  const theme = useTheme();

  return (
    <Dialog
      open={true}
      onClose={() => setFileUrl("")}
      fullScreen
      sx={{
        zIndex: 2300,
        "& .MuiDialog-paper": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          boxShadow: "none",
        },
      }}
    >
      <AppBar
        sx={{
          position: "relative",
          backgroundColor: theme.palette.grey[700],
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setFileUrl("")}
            aria-label="close"
          >
            <Icon>close</Icon>
          </IconButton>
          <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
            {fileName}
          </Typography>
          <CustomIconButton
            color="inherit"
            tooltipText="Download"
            onClick={handleDownloadFileAndClosePreview}
            aria-label="close"
            iconName="download"
          />
        </Toolbar>
      </AppBar>
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "calc(100vh - 64px)",
          padding: 0,
        }}
      >
        <img
          src={fileUrl}
          alt={fileName}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageBigPreview;
